// Página pública "como apagar a conta" (0.54): no site aparece pelo _layout, sem entrar na conta.
// Com o app aberto (link no celular), volta para o início; o botão de apagar fica em Ajustes › Segurança.
import { Redirect } from 'expo-router';
export { ErrorBoundary } from '../components/Falha';
export default function ExcluirConta() { return <Redirect href="/" />; }
